import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DropDownListModule } from '@progress/kendo-angular-dropdowns';
import { GridModule } from '@progress/kendo-angular-grid';

import { MapModule } from '../../../../libs/map/map.module';
import { AuthGuard } from '../../core/auth.guard';
import { AuthService } from '../../core/auth.service';
import { PipesModule } from '../pipes/pipes.module';
import { SharedModule } from '../shared/shared.module';
import { DetailContainerComponent } from './containers/detail-container/detail-container.component';
import { ListContainerComponent } from './containers/list-container/list-container.component';
import { DistributionComponent } from './distribution.component';
import { distributionRoutes } from './distribution.routing';
import { DetailComponent } from './presentation/detail/detail.component';
import { ListComponent } from './presentation/list/list.component';
import { DistributionDetailService } from './services/distribution-detail.service';
import { DistributionListService } from './services/distribution-list.service';
import { NavigationService } from './services/navigation.service';
import { DistributionEffects } from './store/distribution.effects';
import { distributionsReducer } from './store/distribution.reducer';
import { ReasonDialogComponent } from './presentation/reason-dialog/reason-dialog.component';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LayoutModule } from '@progress/kendo-angular-layout';

@NgModule({
    declarations: [
        DistributionComponent,
        ListContainerComponent,
        DetailContainerComponent,
        ListComponent,
        DetailComponent,
        ReasonDialogComponent,
    ],
    imports: [
        CommonModule,
        RouterModule.forChild(distributionRoutes),
        EffectsModule.forRoot([DistributionEffects]),
        StoreModule.forRoot({ distributions: distributionsReducer }),
        StoreDevtoolsModule.instrument(),
        ButtonsModule,
        DropDownListModule,
        GridModule,
        InputsModule,
        DialogModule,
        PipesModule,
        MapModule,
        FormsModule,
        BrowserModule,
        BrowserAnimationsModule,
        LayoutModule,
        SharedModule
    ],
    providers: [
        AuthService,
        AuthGuard,
        DistributionListService,
        DistributionDetailService,
        NavigationService
    ]
})
export class DistributionModule { }



// WEBPACK FOOTER //
// ./src/app/modules/distribution/distribution.module.ts